import { render, staticRenderFns } from "./NonWood.vue?vue&type=template&id=a025bb10&scoped=true&"
import script from "./NonWood.vue?vue&type=script&lang=js&"
export * from "./NonWood.vue?vue&type=script&lang=js&"
import style0 from "./NonWood.vue?vue&type=style&index=0&id=a025bb10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a025bb10",
  null
  
)

export default component.exports